import { clearAssistantFabIntroDone } from '../../use-assistant-fab-intro'
import { useBooksyAssistantStore } from '../../../store'

export function destroyBooksyAssistant (): void {
  const store = useBooksyAssistantStore()

  store.messages = []
  store.sessionId = null
  store.isOpen = false
  store.draft = ''
  store.error = null
  store.isSending = false
  store.voiceAutoSend = false
  store.restoredUserId = null
  clearAssistantFabIntroDone()
}
